// extracted by mini-css-extract-plugin
export var cardInner = "promo-module--cardInner--d79a3";
export var commerce = "promo-module--commerce--7e94c promo-module--promoCard--1e000";
export var edtech = "promo-module--edtech--e891f promo-module--promoCard--1e000";
export var finance = "promo-module--finance--f5d91 promo-module--promoCard--1e000";
export var hospitality = "promo-module--hospitality--0ce5e promo-module--promoCard--1e000";
export var legacy = "promo-module--legacy--aa2e6 promo-module--promoCard--1e000";
export var overlayLink = "promo-module--overlayLink--23518";
export var promo = "promo-module--promo--e8bd9";
export var promoCard = "promo-module--promoCard--1e000";
export var publishing = "promo-module--publishing--a2b1b promo-module--promoCard--1e000";
export var saas = "promo-module--saas--b4815 promo-module--promoCard--1e000";
export var title = "promo-module--title--dce65";
export var video = "promo-module--video--25473 promo-module--promoCard--1e000";